var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "118", height: "64", viewBox: "0 0 118 64", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Symbols", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Read-Receipt-rate-card---iOS", transform: "translate(-201 -64)" },
        React.createElement(
          "g",
          { id: "Group-2", transform: "translate(201 64)" },
          React.createElement("path", { d: "M26 0h66c14.36 0 26 11.64 26 26v34a4 4 0 0 1-4 4H26C11.64 64 0 52.36 0 38V26C0 11.64 11.64 0 26 0z", id: "Rectangle", fill: "#99B2FF" }),
          React.createElement(
            "g",
            { id: "Group-5", transform: "translate(20 18)", fill: "#7593EF" },
            React.createElement("rect", { id: "Rectangle", width: "78", height: "10", rx: "5" }),
            React.createElement("rect", { id: "Rectangle", y: "18", width: "70", height: "10", rx: "5" })
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/svgs/small_bubble.svg